<template lang="pug">
.container-fluid
	.row
		.col-lg-8
			AlertasDelDia
			button.btn.btn-primary.mb-3(v-if="!abrir_publicar" @click="abrir_publicar=true")
				span.fa.fa-paper-plane.mr-2
				| Nueva publicación
			nuevaPublicacion(:abrir_publicar="abrir_publicar" @cerrar="abrir_publicar=false" @cerrarPublicar="abrir_publicar = false")
			.scrolling-container
				publicacion(
					v-for="publicacion in publicaciones"
					:key="publicacion.PublicacionID"
					:publicacion="publicacion"
					@actualizar="actualizaPublicacion(publicacion.PublicacionID)"
				)
		ModalPublicacion(v-if="$route.params.id", :PublicacionID="$route.params.id")

		.col-lg-4
			Calendario
			//ChangeLog
</template>

<script>
import NuevaPublicacion from './componentes/nueva/nuevaPublicacion'
import Publicacion from './componentes/publicacion/publicacion.vue'
import ModalPublicacion from './componentes/publicacion/modalPublicacion'
import AlertasDelDia from './componentes/alertas/alertas-del-dia'
import ChangeLog from './componentes/changelog/change-log'
import Calendario from './componentes/calendario/calendario'
import {mapGetters} from 'vuex'

export default {
	components: {
		nuevaPublicacion: NuevaPublicacion,
		publicacion: Publicacion,
		ModalPublicacion: ModalPublicacion,
		AlertasDelDia,
		ChangeLog,
		Calendario
	},
	data () {
		return {
			adjuntarFicheros: false,
			nueva: {
				PublicacionID: null,
				ficheros: [],
				mensaje: null,
				encuesta: null,
				youtube: null
			},
			abrir_publicar: false
		}
	},
	created () {
		this.getPublicaciones()
	},
	computed: {
		...mapGetters({
			publicaciones: 'muro/publicaciones'
		}),
		ultimoID () {
			if (this.publicaciones.length === 0) {
				return null
			}
			return this.publicaciones[this.publicaciones.length - 1].PublicacionID
		}
	},
	methods: {
		getPublicaciones () {
			this.$store.dispatch('muro/getPublicaciones', this.ultimoID)
		}
	}
}
</script>

<style scoped>
	 .scrolling-container {
		height: 100vh;
		overflow-y: scroll;
	}
</style>





// WEBPACK FOOTER //
// src/modulos/muro/vue/main.vue